var _defs, _sodipodiNamedview;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAitapisskoFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 2390.9868,
    height: 1780.4399,
    viewBox: "0 0 2390.9868 1780.4399",
    sodipodiDocname: "AitapisskoFINAL.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1780.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1116.67,9103.09 c 128.97,-220.28 330.18,-534.77 437.3,-714.31 10.4,-14.32 23.03,-19.31 28.54,-12.73 33.64,33.41 86.06,95.9 160.55,184.68 91.05,108.52 157.27,187.44 181.57,223.09 2.76,3.29 -1.59,18.14 -8.17,23.66 -129.53,52.64 -552.71,222.78 -788.75,308.76 -2.76,-3.29 -14.33,-10.4 -11.04,-13.15 z m 642.24,-1558.64 c -275.75,539.53 -782.308,1418.4 -950.101,1699.27 -43.704,81.48 -124.625,205.41 -175.012,258.9 44.672,46.56 100.383,106.28 150.043,165.48 57.937,69.05 96.035,121.14 131.371,169.94 66.414,-27.7 171.229,-76.42 237.629,-104.12 415.55,-152.53 1380,-519.04 1766.48,-652.78 363.99,-120.48 404.09,-126.11 650.48,87.42 18.67,-4.46 98.65,-82.77 100.77,-106.97 -68.98,-82.21 -200.24,-218.62 -412.68,-471.83 -231.76,-276.23 -307.42,-386.45 -412.26,-511.41 -25.25,9.97 -106.94,72.9 -111.82,93.8 42.03,76.81 84.06,153.61 89.16,199.76 10.62,52.73 -22.27,80.32 -34.89,85.31 -130.59,64.74 -423.71,176.19 -577.44,226.72 -12.09,-1.07 -39.57,-0.42 -50.61,-13.58 -47.43,-49.85 -137.95,-164.42 -209.68,-249.92 -110.36,-131.54 -182.09,-217.04 -217.43,-265.84 -8.28,-9.86 -8.39,-43.39 -0.75,-61 114.22,-191.1 247.02,-420.18 302.92,-467.08 48.8,-35.34 100.35,-67.39 185.77,1.03 57.3,41.58 108.55,82.63 168.08,133.55 21.43,-1.18 98.65,-82.77 103.53,-103.68 -80.01,-95.36 -197.48,-215.33 -357.5,-406.07 -102.08,-121.67 -205.34,-264.77 -301.91,-379.87 -24.71,3.93 -106.4,66.86 -111.8,93.8 156.95,260.54 165.98,331.42 37.65,579.17",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4473.04,9525.76 c -64.99,-49.26 -202.77,-137.53 -418.29,-300.88 -191.58,-145.2 -306.96,-248.8 -392.48,-313.62 -23.23,9.32 -91.47,92.25 -88.16,116.31 46.96,51.75 79.4,87.11 103.24,126.72 37.52,49.99 15.84,92.8 -42.96,177.5 -53.62,77.86 -214.38,289.95 -338.84,454.16 -88.16,116.31 -191.87,253.15 -239.37,308.75 -20.74,27.3 -58.7,63.2 -88.77,67.3 -44.69,9.3 -81.6,8.2 -196.48,-25 -23.23,9.3 -73.42,89.8 -73.54,111.3 78.69,59.6 394.75,374.6 514.77,578.6 106.31,-140.2 292.17,-392.6 437.37,-584.1 132.23,-174.5 305.96,-403.71 428.65,-558.49 77.79,-102.63 116.46,-111.02 170.48,-97.01 29.13,11.31 77.96,32.16 153.33,67.74 20.64,-5.9 78.61,-96.62 71.05,-129.28 z M 2931.56,10969.7 c -10.05,-50.7 -174.97,-202.6 -235.01,-215.8 -79.72,-22.7 -158.01,9.5 -229.56,68.4 -38.79,29.8 -111.39,125.6 -109.95,180.6 17.6,83.4 107.99,205.7 196.93,273.1 85.53,64.9 161.01,79 194.5,77.4 46.45,-18.6 105.16,-81.9 125.9,-109.2 51.85,-68.4 75.63,-185.1 57.19,-274.5",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3685.1,11515.3 c 101.76,100 274.61,346.9 307.9,428.9 12.98,12 61.5,48.5 82.38,55.1 36.28,-92.7 131.79,-275.4 266.23,-519.9 8.27,-15 24.06,-25.9 31.59,-21.8 78.99,43.5 302.23,180.9 401.71,240.5 23.88,-70.1 65.43,-199.1 96.82,-265.2 -114.9,-58.2 -246.55,-130.6 -374.44,-200.9 -3.76,-2.1 -6.77,-23.4 -2.63,-30.9 78.59,-142.9 221.67,-412 318.88,-588.8 74.45,-135.4 113.75,-206.9 170.16,-273.9 54.72,-72.7 159.65,-103.2 272.49,-41.2 75.23,41.4 129.21,85.8 174.16,164.4 17.86,-14.7 61.3,-93.7 68.63,-133.7 -28.8,-197.1 -170.42,-358.27 -339.68,-451.34 -176.79,-97.21 -346.98,-117.31 -486.7,-32.49 -112.26,70.54 -168.1,172.13 -286,386.53 -103.4,188 -285.79,528.6 -372.65,686.6 -8.27,15 -26.14,29.7 -43.25,25.2 -56.8,-21.4 -128.26,-60.7 -188.82,-84.2 -14.48,26.3 -47.37,130.7 -50.94,172.8 42.69,38.2 107.58,98.4 127.7,124.1 7.53,4.2 6.78,23.3 2.27,40.4 l -175.81,319.8",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6217.06,11300.6 c -89.74,-70.4 -266.44,-192.2 -299.12,-243.7 -8.18,-16.3 -0.21,-108.6 11.93,-145.3 68.81,-207.8 241.12,-250.2 363.36,-209.8 36.67,12.2 67.92,27.1 81.55,54.2 9.53,12.2 13.65,40.7 0.16,81.4 -33.67,129 -115.98,377.6 -138.92,446.9 -2.69,8.1 -14.89,17.6 -18.96,16.3 z m -193.25,433.4 c -94.89,68.1 -212.97,69.6 -318.92,34.6 -89.64,-29.7 -163.05,-81.2 -180.78,-123.2 -21.8,-43.4 -47.98,-237.5 -54.86,-284.9 -14.98,-23.1 -165.62,-5.1 -169.63,20.7 -9.45,28.5 -22.56,259.3 -2.14,293.2 157.9,219.5 423.01,429.4 553.41,472.6 220.04,72.9 422.19,22.2 567.21,-88 121.98,-95.3 192.28,-239.3 238.15,-377.8 63.41,-191.6 142.97,-459.1 198.29,-626.2 24.28,-73.4 75.72,-146.8 161.29,-118.4 44.83,14.8 76.08,29.7 127.73,64.9 12.2,-9.5 40.42,-149.4 33.6,-169.8 -73.57,-132.8 -253,-260.1 -391.55,-305.9 -138.54,-45.9 -241.66,-21.3 -290.39,44 -14.9,17.6 -32.49,43.5 -43.31,62.5 -2.7,8.1 -19,2.7 -17.65,-1.3 -151.07,-199.3 -326.42,-325.1 -387.55,-345.4 -93.72,-31 -191.44,-22.7 -280.95,15.5 -132.9,60 -239.88,191.9 -292.49,350.8 -17.55,53 -29.45,211.8 -11.69,267.4 93.88,112.5 560.04,398 689.22,513.1 14.95,9.5 19.08,38 17.76,55.6 -4.02,25.8 -5.37,29.9 -13.47,54.3 -24.28,73.4 -60.79,142.7 -131.28,191.7",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7894.26,12192.8 c -16.4,-9.9 -35.65,-37.4 -37.08,-72 5.69,-120.1 54.48,-654.5 78,-833.4 11.04,-80.9 48.82,-172.5 131.15,-230.3 95.89,-65.2 182.16,-66.7 246.32,-61.3 59.89,5 139.03,37.4 192.86,115.1 68.81,104.8 101.63,279.8 83.46,498 -19.22,231 -76.96,407.1 -180.68,514.7 -99.45,108.1 -209.95,141.9 -334,131.6 -51.33,-4.3 -135.47,-28.5 -180.03,-62.4 z m 404.75,-2326.7 c -410.66,-34.18 -700.48,-71.23 -1081.91,-146.06 -19.25,24.25 -40.63,125.84 -25.65,152.93 75.93,19.24 155.78,43.12 205.33,68.78 70.59,31.72 73.09,105.15 68.82,208.15 -3.91,150.5 -38.8,569.7 -71.92,967.5 -37.75,453.4 -57.69,693 -86.9,888.7 -9.98,68.1 -22.1,110.2 -84.48,135.1 -53.11,17.1 -122.97,28.5 -179.66,36.7 -10.69,25 -13.89,115.2 -3.19,141.9 202.84,47.1 577.51,203.2 750.04,303.7 8.21,5 41,-26.8 41.71,-35.3 3.2,-38.5 8.54,-154.4 14.96,-231.4 0.71,-8.5 14.25,-16 22.45,-11 170.05,130.4 369.68,267.6 540.79,281.9 183.95,15.3 344.35,-48.9 461.26,-159.8 154.34,-146.5 236.31,-355 253.41,-560.3 30.62,-367.9 -87.39,-606 -282.4,-798.9 -202.5,-206.4 -536.88,-329 -759.31,-347.5 -21.4,-1.8 -72.73,-6 -90.19,-3.2 -8.56,-0.7 -11.77,-13.9 -11.06,-22.4 4.98,-111.6 34.54,-415 52.71,-529.8 12.83,-102.3 38.49,-151.8 138.65,-165 52.41,-8.6 156.14,-12.9 247.04,-18.2 11.05,-29.25 6.05,-124.43 -9.28,-147.24 l -111.22,-9.26",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10011.2,12870.5 c -41.62,-30.7 -265.85,-31.6 -319.07,-0.9 -74.2,37 -110.26,113.6 -123.4,205.3 -8.51,48.2 2.48,167.9 40.6,207.5 69.22,49.7 218.46,79.1 329.61,68.9 106.86,-9.8 172.06,-50.3 195.76,-74 21.8,-45.1 22.5,-131.4 19.3,-165.6 -7.8,-85.5 -68.9,-187.6 -142.8,-241.2 z m 164.5,-2105.7 c -81.2,7.5 -242.48,35.2 -511.77,60 -239.37,21.9 -394.43,23.2 -501.29,33 -10.86,22.6 -5.33,129.8 13.34,145.4 69.57,6.5 117.37,10.7 161.68,23.9 61.41,11.6 74.28,57.8 87.98,160 12.89,93.7 37.22,358.7 56.06,563.9 13.34,145.3 29.03,316.3 31.42,389.3 3.15,34.2 -0.7,86.3 -20.11,109.6 -26.78,37 -54.74,61.1 -161.96,114.1 -10.85,22.5 6.33,115.8 20.73,131.7 98.3,-9.1 544.06,10.4 770.32,80.1 -16.1,-175.2 -49,-486.9 -71,-726.2 -20,-218 -46.3,-504.4 -60.06,-701.4 -11.78,-128.3 11.16,-160.5 60.46,-186.6 29.1,-11.3 79.2,-28.8 158.9,-53.4 11.3,-18.3 -7.1,-124.3 -34.7,-143.4",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11792.6,11632.3 c -22.9,-2.9 -124.8,14.7 -139.2,27.3 12.2,183.2 -6.3,316.6 -89.8,404.9 -42.3,42 -96.1,73.8 -166.7,92.2 -120.5,31.3 -224.1,-26 -249,-121.5 -30.3,-116.3 -5,-189.4 313.2,-449.7 286.2,-229.7 357.4,-399.1 297.9,-627.6 -95.1,-365.5 -503.4,-485.5 -893.9,-383.8 -216,56.2 -383.8,144.2 -501.8,219.3 6.1,91.6 62.8,462.7 77.1,534.4 15.7,9.2 128.2,15.4 152,4.8 9.2,-237.5 54.6,-386.8 159.7,-494 55.7,-58.9 141.7,-103.4 208.1,-120.7 133,-34.6 234.4,14.4 260.4,114.1 29.2,112.1 -28.3,198.1 -191.4,338.1 -374.9,314.9 -454.3,504.2 -388.3,757.6 77.8,299.1 375.3,487.8 844.7,365.6 66.5,-17.4 209.7,-63.5 289.6,-97.6 99.5,-43.6 147.2,-64.9 197,-77.9 -66.9,-137.8 -120.6,-310.2 -179.6,-485.5",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13372.3,10950.2 c -23.1,1.4 -119.9,37.7 -131.8,52.8 46,177.7 52.6,312.2 -13.1,414.4 -33.7,49.2 -80.7,90.4 -146.7,121.6 -112.5,53.1 -225,16.1 -267.2,-73.2 -51.3,-108.7 -40,-185.2 224.3,-500 238.6,-278.9 277.2,-458.5 176.3,-672 -161.3,-341.5 -584.8,-383.59 -949.6,-211.2 -201.8,95.3 -350.4,213 -452.4,308.6 23,88.9 147.6,443 174.9,510.8 17.1,6.2 128.8,-8.6 150.3,-23.5 -35.1,-235 -18.2,-390.2 65.2,-515.1 43.8,-68.1 120,-127.9 182.1,-157.2 124.2,-58.7 233,-29.3 277,63.8 49.5,104.8 9,199.9 -125.3,367.8 -309.9,379 -352.8,579.7 -241,816.4 132,279.5 459.4,409.7 898,202.5 62.1,-29.3 194.3,-101.3 266.4,-149.6 89.7,-61.4 132.6,-91.1 179.2,-113.1 -91.4,-123 -176.1,-282.4 -266.6,-443.8",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14920.3,10518.3 c 215.4,-170.5 526.4,-392.8 716.6,-511.5 5.7,-20.71 -58.7,-111.89 -91.4,-119.27 -144.4,72.79 -249.6,104.82 -367.4,92.34 -156.5,-20.66 -358.5,-44.27 -501.3,-75.37 -12.1,-1.59 -7.8,-10.22 -13.1,-17.03 -28.3,-156.81 -40,-856.39 -1.7,-1053.41 19.5,-101.51 38.1,-126.61 159.7,-236.08 3.2,-24.07 -78.3,-102.19 -105.8,-102.76 -88.8,46.45 -326.5,223.27 -459.3,325.13 -92.8,76.54 -136.4,174.87 -142.5,244.48 -14.9,135.81 11,472.93 34.4,736.26 3.3,67.79 10,132.96 -13.6,172.71 -135,-183.15 -182,-244.47 -273.4,-363.69 -82.8,-115.02 -74.6,-153.74 -23,-220.4 33.1,-41.56 55.1,-69.27 90.8,-107.42 -5.5,-28.28 -78.4,-102.19 -109.3,-100.15 -85.2,65.3 -186.3,159.1 -400.9,323.65 -190.8,146.26 -307.6,219.62 -406.4,295.37 -4,30.09 61.3,115.25 88.8,115.81 59.7,-34.97 95.6,-51.67 134.1,-64.96 63.4,-16.12 99.7,10.1 169.2,86.63 74.7,83.36 299.3,376.26 416.9,529.56 689.5,899.3 801.8,1045.8 844.6,1115.7 35.8,53.7 50.9,101.6 17.1,149.2 -23.6,39.8 -60.1,83.9 -103.4,133.3 2.9,24.9 60.4,99.8 81,105.6 219.8,-157.7 593.9,-347.1 741,-395.1 7.6,-11.2 -11.9,-72 -23.1,-79.5 -61.2,-23.4 -110.6,-66.7 -317.8,-329.8 -157.5,-198.3 -322.8,-406.9 -850.4,-1095 52.9,-29.8 124.9,-41.7 207.3,-40 204.4,5.5 504.7,72.8 546.5,127.3 23.5,30.6 23,58.1 -10.9,105.7 -36.4,44.2 -131.5,138.7 -135.8,147.4 5.5,28.3 81,105.6 102.5,105.3",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16339.9,8934.7 c -133.4,36.53 -292.4,-18.72 -547.6,-221.88 -463.5,-368.91 -579.6,-691.74 -435.3,-873.1 32.1,-40.31 77.6,-69.92 119.9,-74.71 134.6,-24.48 305.1,50.86 560.4,254.02 399.6,318.12 570.7,640.82 405,849.04 -24.1,30.23 -64.3,53.13 -102.4,66.63 z m 176.3,-1324.45 c -278.7,-221.88 -577.2,-267.39 -844.4,-172.87 -152.7,54 -365.5,197.32 -493.9,358.53 -406.3,510.5 -265.6,995.51 134,1313.62 255.3,203.16 553,242.65 814.9,154.85 164.8,-55.38 364.3,-181.91 511.3,-366.62 374.2,-470.2 271.1,-974.74 -121.9,-1287.51",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3607.85,6111.08 c -185.01,125.19 -232.12,272.84 -140.78,407.83 57.49,84.96 142.66,133.84 187.12,103.75 19.06,-12.9 25.22,-44.85 0.01,-75.26 -61.49,28.88 -117.45,11.18 -157.21,-47.58 -63.95,-94.49 -11.24,-203.08 158.69,-318.07 169.13,-114.44 289.53,-122.99 352.4,-30.08 38.15,56.38 38.14,131.63 -20.76,190.01 14.55,28.35 42.35,48.9 67.76,31.71 53.99,-36.54 42.56,-152.66 -19.77,-244.78 -89.73,-132.61 -243.23,-142.18 -427.46,-17.53",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4213.49,6922.84 c -165.25,137.13 -275.63,152.74 -347.25,66.42 -70.41,-84.84 -35.33,-191.18 129.92,-328.32 164.51,-136.51 275.51,-151.38 345.91,-66.54 71.63,86.31 35.93,191.92 -128.58,328.44 z m -271.81,-327.55 c -179.27,148.76 -207.43,290.47 -102.74,416.62 105.29,126.89 249.77,125.35 429.04,-23.41 178.53,-148.15 206.68,-289.86 101.39,-416.75 -104.69,-126.16 -249.16,-124.61 -427.69,23.54",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4735.86,7401.74 c 140.94,-143.74 156.61,-273.36 45.73,-382.09 -108.15,-106.04 -228.66,-91.3 -375.64,58.6 l -182.55,186.18 c -26.17,26.68 -53.72,52.04 -80.02,65.18 0.77,10.16 4.34,28.43 19.4,43.19 18.48,18.12 42.22,19.92 61.02,0.75 l 238.92,-243.66 c 129.53,-132.1 220.12,-157.4 294.04,-84.91 75.98,74.5 49.19,177.11 -72.96,301.68 l -184.56,188.23 c -26.18,26.7 -54.4,51.38 -80.71,64.52 0.78,10.16 3.66,27.75 19.4,43.19 17.8,17.45 42.22,19.92 61.02,0.75 l 236.91,-241.61",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5049.02,7290.82 c -10.36,28.48 -35.66,63.47 -58.29,92.01 l -273.54,343.39 c -29.77,37.55 -55.7,67.15 -75.54,84.45 2.78,18.1 33.57,42.53 43.59,40.68 172.09,-51.93 497.11,-150.17 640.74,-206.32 l -309.37,363.9 c -29.06,32 -41.8,63.5 -32.74,82.92 7.07,8.06 16.83,15.8 28.83,19.19 10.56,-14.86 31.28,-36.36 44.39,-52.88 l 303.75,-383.04 c 29.18,-36.81 50.78,-62.49 70.46,-81.14 -0.8,-12.87 -23.95,-36.13 -38.64,-39.21 -215.67,46.73 -494.29,145.08 -634.78,198.82 l 326.93,-389.13 c 18.62,-21.93 14.17,-48.7 -1.61,-61.21 -11.26,-8.94 -23.25,-12.33 -34.18,-12.43",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5459.89,7770.85 c -19.75,30.6 -19.29,61.7 29.97,84.38 3.53,-12.55 10.3,-23.03 19.41,-35.39 42.73,-59.14 116.24,-68.73 195.18,-17.79 68.46,44.18 95.99,107.59 53.36,173.64 -41.58,64.43 -106.44,65.92 -220.35,58.57 -125.9,-8.23 -213.38,-8.79 -269.01,77.38 -60.3,93.43 -6.32,183.04 85.49,242.3 95.04,61.34 183.67,67.21 224.74,3.58 12.48,-19.33 15.1,-39.31 -8.3,-57.85 -5.69,-7.09 -15.07,-12 -24.97,-16.11 -4.58,14.16 -12.66,24.92 -21.83,33.83 -34.99,43.59 -95.64,42.1 -156.85,2.59 -49.12,-31.71 -90.61,-85.87 -50.07,-148.69 41.59,-64.43 112.89,-61.77 219.09,-54.84 117.13,9.43 217.36,7.94 275.06,-81.46 46.78,-72.49 44.96,-177.49 -93.57,-266.9 -125.64,-81.09 -215.25,-62.48 -257.35,2.76",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6314.76,8123.63 -269.38,-142.68 c -22.87,-12.12 -46.14,-7.09 -59.16,17.48 l -235.94,443.44 c -17.95,33.88 -35.74,61.34 -57.23,81.42 8.47,22.93 20.23,33.49 49.03,48.75 l 255.83,135.5 c 21.18,11.21 40.07,-44.95 25.07,-63.74 -80.42,-26.33 -159.46,-57.34 -240.38,-99.12 l 116.65,-220.24 208.4,110.36 c 10.56,-11.75 18.19,-26.15 21.53,-40.66 l -208.39,-110.36 133.65,-250.3 c 80.87,43.92 169.47,106.03 230.56,152.49 24.47,-1.15 52.64,-50.23 29.76,-62.34",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6505.56,8260.51 c 78.87,35.02 160.23,83.63 219.58,122.76 23.04,-2.6 48.69,-57.31 24.92,-67.56 l -256.23,-110.36 c -23.77,-10.23 -46.57,-3.35 -57.57,22.19 l -202.63,468.05 c -14.79,34.34 -32.22,67.55 -52.03,89.29 4.39,9.19 14.31,24.95 34.56,33.67 23.77,10.24 46.57,3.36 57.19,-21.3 l 232.21,-536.74",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6859.41,8388.23 -178.23,490.08 c -12.71,35.15 -28.12,69.34 -46.59,92.22 4.93,8.91 15.77,24.05 36.5,31.54 24.34,8.81 47.58,0.91 56.71,-24.34 l 177.33,-490.4 c 12.71,-35.16 27.23,-69.66 46.59,-92.22 -4.92,-8.92 -15.77,-24.05 -36.5,-31.55 -24.34,-8.8 -47.01,0.33 -55.81,24.67",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7093.26,8442.01 c 1.54,30.28 -8.15,72.36 -17.91,107.46 l -118.41,422.82 c -12.83,46.19 -25.19,83.55 -36.73,107.21 9.59,15.6 47.46,26.11 55.99,20.53 138.34,-114.81 399.59,-331.81 510.07,-439.43 l -143.46,455.67 c -14.31,40.8 -13.8,74.77 2.11,89.14 9.65,4.67 21.66,8 34.03,6.46 3.94,-17.81 14.67,-45.68 20.31,-65.99 l 130.84,-471.12 c 12.57,-45.26 22.47,-77.34 33.35,-102.17 -5.75,-11.55 -36.13,-23.97 -50.86,-21.09 -180.53,126.97 -398.98,326 -507.51,430.18 l 149.82,-485.74 c 8.62,-27.45 -5.91,-50.39 -25.31,-55.78 -13.85,-3.85 -26.22,-2.31 -36.33,1.85",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7631.73,8926.31 c -37.19,220.27 38.97,356.61 206.29,384.86 96.43,16.28 191.69,-12.36 200.14,-62.47 4.16,-24.58 -14.7,-51.09 -54.1,-53.86 -21.57,64.42 -73.96,92.52 -138.24,81.67 -121.96,-20.59 -164.11,-133.69 -129.96,-335.99 33.99,-201.37 110.95,-294.35 231.96,-273.92 121.95,20.58 120.6,138 108.47,209.85 -12.45,73.74 -41.86,115.44 -91.83,117.7 1.38,20.65 20.74,32.67 45.32,36.82 51.05,8.62 103.76,-21.37 121.63,-127.25 20.11,-119.12 -24.54,-246.25 -180.53,-272.59 -168.27,-28.4 -282.13,75.86 -319.15,295.18",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8454.78,9041.44 c -8.29,223.22 83,348.45 245.86,354.5 102.51,3.81 192.25,-36.03 194.24,-89.68 0.86,-22.99 -21.28,-46.84 -60.71,-44.46 -13.03,66.66 -60.36,101.36 -131.25,98.73 -114.01,-4.24 -170.49,-110.9 -162.87,-315.92 7.58,-204.06 71.81,-306.24 183.9,-302.08 68.02,2.52 128.73,46.99 141.03,128.99 31.47,5.01 64.47,-5.28 65.61,-35.93 2.42,-65.15 -98.02,-124.52 -209.15,-128.65 -159.99,-5.94 -258.4,112.24 -266.66,334.5",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9467.22,9032.99 c 12.76,214.35 -39.98,312.56 -151.93,319.23 -110.05,6.55 -175.02,-84.65 -187.79,-299 -12.7,-213.4 40.98,-311.67 151.03,-318.23 111.96,-6.66 175.97,84.6 188.69,298 z m -424.88,25.3 c 13.84,232.53 111.42,339.08 275.06,329.33 164.59,-9.8 248.83,-127.17 234.99,-359.7 -13.8,-231.58 -111.37,-338.13 -275.97,-328.33 -163.63,9.74 -247.88,127.12 -234.08,358.7",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9749.53,8711.76 c 85.47,-11.81 180.24,-13.37 251.27,-11.38 18.2,-14.36 11.2,-74.38 -14.38,-70.55 l -275.93,41.23 c -25.6,3.82 -41.35,21.69 -37.24,49.19 l 74.44,504.58 c 5.52,36.98 8.2,74.39 2.83,103.3 8.57,5.5 25.31,13.66 47.11,10.41 25.61,-3.83 41.36,-21.69 37.39,-48.24 l -85.49,-578.54",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10193.6,8632.79 c 84.3,-18.24 178.7,-26.98 249.6,-30.38 17.1,-15.69 5.6,-75 -19.7,-69.25 l -272,62.01 c -25.2,5.75 -39.6,24.76 -33.4,51.86 l 112.5,497.46 c 8.3,36.45 13.8,73.54 10.6,102.78 9,4.83 26.3,11.71 47.8,6.8 25.2,-5.75 39.6,-24.75 33.6,-50.92 l -129,-570.36",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10875.7,8395.17 -290.7,91.5 c -24.7,7.77 -37.5,27.87 -29.1,54.39 l 149.8,479.41 c 11.5,36.57 18.6,68.52 17.8,97.92 22.3,10.08 38,9.13 69.1,-0.65 l 276.2,-86.91 c 22.8,-7.19 -3.9,-60.09 -27.8,-62.61 -75.2,38.74 -152.8,73.21 -239.4,101.46 l -74.8,-237.73 224.9,-70.79 c -0.9,-15.78 -5.8,-31.32 -13.8,-43.89 l -224.9,70.79 -84.3,-270.94 c 88.1,-26.71 194.5,-46.14 270.5,-56.98 16.4,-18.22 1.2,-72.74 -23.5,-64.97",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11112.5,8663.68 c 85.9,206.18 221.2,281.68 371.7,218.99 94.6,-39.45 159.4,-113.2 138.8,-162.75 -8.9,-21.23 -38.9,-33.62 -73.7,-14.97 16,66 -12.4,117.33 -77.9,144.62 -105.3,43.88 -201.3,-29.34 -280.2,-218.71 -78.5,-188.47 -63,-308.16 40.6,-351.3 62.8,-26.19 136.5,-11.22 182,58.09 30.7,-8.63 56.4,-31.78 44.6,-60.1 -25.1,-60.17 -141.2,-72.04 -243.8,-29.26 -147.8,61.58 -187.7,210.1 -102.1,415.39",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12138.9,8474.08 c -42.2,35.15 -90.2,77.71 -142.3,110.48 L 11756.3,8125 c -17.4,-33.1 -33.1,-67.09 -36.7,-96.6 -9.9,-2.38 -28.4,-4.58 -47.9,5.68 -22.9,12.04 -31.5,34.93 -19.4,57.85 l 276.4,528.3 c -55.7,23.84 -118.4,40.53 -170.9,54.02 -15,18.74 2.8,75.42 24.1,64.27 l 396.3,-208.2 c 21.2,-11.15 -15.3,-58.01 -39.3,-56.24",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11979.7,7909.25 270.3,446.01 c 19.4,31.94 36.4,65.37 42.7,94.1 10,1.75 28.6,2.79 47.5,-8.68 22.1,-13.46 30.5,-36.53 16.5,-59.46 l -271.1,-445.51 c -19.5,-31.94 -37.3,-64.88 -42.7,-94.11 -10.1,-1.75 -28.7,-2.77 -47.5,8.69 -22.1,13.46 -29.2,36.85 -15.7,58.96",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12907.6,8021.83 c -7.2,-10.19 -19.2,-20.52 -32.5,-31.08 l -506.5,-372.49 c -22,3.76 -38.5,11.91 -49.5,19.64 -22.7,16.02 -33.2,32.78 -28,50.2 l 189.9,600.44 c 5.1,13.97 8.6,33.82 6.6,49.31 13.3,2.31 30.1,1.07 49.7,-12.73 21.1,-14.92 29.9,-34.03 22.2,-53.25 l -199.7,-591.15 463.1,369.18 c 7.4,5.4 16.9,13.93 22.4,21.76 5.5,7.84 8.4,15.22 8,21.27 12.2,-2.71 22.5,-6.44 37.3,-16.94 25.1,-17.67 31,-35.91 17,-54.16",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12881.4,7206.83 -232.9,196.76 c -19.7,16.7 -23.8,40.17 -5.8,61.41 l 323.5,384.33 c 24.7,29.29 43.6,56.04 54.2,83.47 24.4,0.69 38.6,-6.28 63.5,-27.31 l 221.1,-186.86 c 18.4,-15.47 -26.7,-53.95 -49.7,-47.05 -54.5,64.82 -112.7,126.59 -181.7,186.1 l -160.8,-190.39 180.1,-152.21 c -7,-14.19 -17.5,-26.64 -29.7,-35.15 l -180.1,152.21 -182.5,-217.37 c 71,-58.67 161.6,-117.72 227.5,-157.07 8.1,-23.14 -26.9,-67.58 -46.7,-50.87",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13225.1,6934.66 c 59.9,-62.17 133.4,-122.03 190.4,-164.44 5.4,-22.54 -37.2,-65.34 -55,-46.49 l -191.2,203.11 c -17.7,18.85 -19.1,42.62 1.2,61.68 l 370.7,350.31 c 27.2,25.63 52.4,53.36 66.1,79.4 10.1,-0.99 28.3,-4.93 43.4,-20.98 17.8,-18.85 19.1,-42.63 -0.4,-61.02 l -425.2,-401.57",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13525.2,6597.92 c 55,-66.48 123.8,-131.69 177.5,-178.26 3.7,-22.89 -42.1,-62.37 -58.3,-42.24 l -175.5,216.9 c -16.3,20.12 -15.8,43.93 5.8,61.42 l 395.9,321.55 c 29.1,23.53 56.4,49.28 71.9,74.22 10.1,-1.75 27.9,-7.03 41.8,-24.18 16.3,-20.13 15.8,-43.94 -5.1,-60.82 l -454,-368.59",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13972.5,6494.4 c 184.9,125.35 339.5,114.31 430.9,-20.61 57.6,-84.92 71.4,-182.14 26.9,-212.27 -19,-12.91 -51,-6.77 -69.8,27.92 49.6,46.39 53.9,104.92 14.1,163.65 -64,94.44 -184.4,85.8 -354.2,-29.32 -169.1,-114.59 -221.7,-223.22 -158.8,-316.08 38.3,-56.35 108.1,-84.26 184.2,-51.23 20.9,-24.04 29.7,-57.48 4.3,-74.69 -54,-36.59 -157.6,17.13 -220,109.19 -89.8,132.54 -41.7,278.63 142.4,403.44",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6085.08,510.801 C 4606.44,510.801 3764.1,1457.3 3468.85,2343 l 81.45,27.2 c 87.03,-261.1 305.64,-760.6 791.85,-1172 471.71,-399.2 1058.12,-601.501 1742.93,-601.501 344.36,0 677.9,92.5 991.34,275.102 252.03,146.899 491.92,351.899 713.02,609.499 378.18,440.6 572.23,887.7 574.14,892.2 l 78.91,-33.8 C 8434.5,2321 8242.3,1877.7 7856.14,1427.2 7342.26,827.699 6729.84,510.801 6085.08,510.801",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10577.7,1776.7 c -669.14,0 -1149.42,399.1 -1172.18,418.3 l 55.43,65.6 c 6.05,-5.1 614.45,-509.4 1388.55,-374.5 612.9,106.8 1163.7,575.6 1637.2,1393.4 l 74.3,-43 c -487.1,-841.3 -1058.3,-1324.2 -1697.8,-1435.2 -98.3,-17.1 -193.7,-24.6 -285.5,-24.6",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6870.31,842.5 c -164.98,0 -311.71,39.699 -431.66,90.199 C 6127.06,1063.9 5931.87,1288.9 5923.71,1298.5 l 65.17,55.8 c 1.88,-2.2 192.03,-220.8 485.78,-343.6 388.77,-162.598 768.19,-88.7 1127.79,219.5 l 55.87,-65.2 C 7375.37,922.5 7104.47,842.5 6870.31,842.5",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12808.6,1158.7 c -187.3,0 -375.8,14.9 -565.1,44.8 -917.3,144.8 -1541.8,598.9 -1548,603.4 l 50.9,69.2 c 6.1,-4.5 616.5,-447.6 1514.1,-588.4 525.8,-82.4 1046.2,-46.6 1546.9,106.6 626.5,191.7 1224.3,569 1776.7,1121.4 l 60.7,-60.7 c -563.1,-563.1 -1173.6,-947.8 -1814.6,-1143.5 -333.4,-101.8 -675.3,-152.8 -1021.6,-152.8",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4254.75,1164.6 c -753.36,627.8 -2024.45,761.7 -2037.2,763 l 8.54,85.4 c 53.12,-5.3 1309.75,-137.5 2083.61,-782.4 l -54.95,-66",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5956.31,1712.7 c 0,-284.5 -230.62,-515.1 -515.11,-515.1 -284.48,0 -515.1,230.6 -515.1,515.1 0,284.5 230.62,515.1 515.1,515.1 284.49,0 515.11,-230.6 515.11,-515.1",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9958.28,3329 c -475.74,208.04 -908.27,101.84 -1041.99,-204 -133.72,-305.8 82.01,-695.5 557.74,-903.5 475.73,-208 1288.07,96.4 1288.07,96.4 0,0 -328.1,803.1 -803.82,1011.1",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9883.97,2277.6 c -143.82,0 -264.39,20.8 -358.36,61.9 -388.73,170 -599.95,485.5 -491.33,733.9 64.26,147 231.2,234.7 446.56,234.7 133.35,0 280.6,-33.5 425.85,-97.1 294.61,-128.8 552.91,-557 679.01,-815.4 -158.7,-47.7 -437.7,-118 -701.72,-118 -0.03,0 0.01,0 -0.01,0",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7965.9,3329 c 475.73,208.04 908.26,101.84 1041.98,-204 133.72,-305.8 -82,-695.5 -557.74,-903.5 -475.73,-208 -1288.1,96.4 -1288.1,96.4 0,0 328.12,803.1 803.86,1011.1",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8040.2,2277.6 c -263.69,0 -542.22,70.1 -701.12,117.8 36.98,75.7 90.64,177.9 157.87,285.3 170.69,272.7 350.69,456.1 520.54,530.3 145.24,63.6 292.5,97.1 425.84,97.1 215.37,0 382.31,-87.7 446.57,-234.7 108.62,-248.4 -102.61,-563.9 -491.34,-733.9 -93.98,-41.1 -214.54,-61.9 -358.36,-61.9",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15801.6,2742.9 c -62.6,0 -121.5,27.3 -165.8,76.7 -156.7,175.2 -419.8,533 -419.8,961.34 0,414.23 250.8,835.56 400.3,1049.83 44.9,64.39 112.5,101.32 185.3,101.32 72.8,0 140.3,-36.93 185.2,-101.32 149.5,-214.3 400.3,-635.66 400.3,-1049.83 0,-428.34 -263,-786.14 -419.8,-961.34 -44.3,-49.4 -103.1,-76.7 -165.7,-76.7",
    style: {
      fill: "#371147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16258.3,3780.93 c 0,-394.37 -259,-732.53 -387,-875.43 -40.3,-45.1 -99.1,-45.1 -139.5,0 -127.9,142.9 -387,481.06 -387,875.43 0,384.5 246.3,788.57 377.1,976.17 43,61.62 116.3,61.62 159.3,0 130.9,-187.6 377.1,-591.67 377.1,-976.17",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16781.3,2227.8 c -428.4,0 -786.2,263 -961.4,419.8 -49.4,44.3 -76.7,103.1 -76.7,165.7 0,62.6 27.3,121.5 76.7,165.8 175.2,156.8 533,419.77 961.4,419.77 414.2,0 835.5,-250.77 1049.8,-400.27 64.4,-44.9 101.3,-112.5 101.3,-185.3 0,-72.8 -36.9,-140.3 -101.3,-185.2 -214.3,-149.5 -635.7,-400.3 -1049.8,-400.3",
    style: {
      fill: "#371147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16781.2,2356.6 c -394.3,0 -732.5,259 -875.4,387 -45.1,40.3 -45.1,99.2 0,139.5 142.9,127.9 481.1,387 875.4,387 384.5,0 788.6,-246.3 976.2,-377.1 61.6,-43 61.6,-116.3 0,-159.3 -187.6,-130.9 -591.7,-377.1 -976.2,-377.1",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15813.7,682.5 c -72.8,0 -140.4,36.898 -185.3,101.301 -149.5,214.301 -400.3,635.699 -400.3,1049.899 0,428.3 263,786.1 419.8,961.3 44.3,49.4 103.2,76.7 165.8,76.7 62.6,0 121.4,-27.3 165.7,-76.7 156.8,-175.2 419.8,-533 419.8,-961.3 0,-414.3 -250.8,-835.598 -400.3,-1049.899 C 15954,719.398 15886.5,682.5 15813.7,682.5",
    style: {
      fill: "#371147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15356.9,1833.7 c 0,394.3 259.1,732.5 387,875.4 40.3,45.1 99.2,45.1 139.5,0 128,-142.9 387,-481.1 387,-875.4 0,-384.5 -246.2,-788.6 -377.1,-976.2 -43,-61.602 -116.3,-61.602 -159.3,0 -130.8,187.6 -377.1,591.7 -377.1,976.2",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14834,2215.7 c -414.3,0 -835.6,250.8 -1049.9,400.3 -64.3,44.9 -101.3,112.4 -101.3,185.2 0,72.9 37,140.4 101.3,185.3 214.3,149.5 635.7,400.29 1049.9,400.29 428.3,0 786.1,-262.99 961.3,-419.79 49.5,-44.3 76.7,-103.1 76.7,-165.8 0,-62.6 -27.2,-121.4 -76.7,-165.7 -175.2,-156.8 -533,-419.8 -961.3,-419.8",
    style: {
      fill: "#371147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14834,3258 c 394.4,0 732.5,-259.1 875.4,-387 45.1,-40.3 45.1,-99.2 0,-139.5 -142.9,-127.9 -481,-387 -875.4,-387 -384.5,0 -788.6,246.2 -976.2,377.1 -61.6,43 -61.6,116.3 0,159.3 187.6,130.9 591.7,377.1 976.2,377.1",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9517.9,2256.3 c 0,519.2 -270.59,872.9 -604.37,872.9 -333.79,0 -604.38,-353.7 -604.38,-872.9 0,-519.3 604.38,-1141.6 604.38,-1141.6 0,0 604.37,622.3 604.37,1141.6",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8913.53,1307.8 c -54.55,64.3 -126.73,154.4 -198.23,259 -181.45,265.7 -277.37,504.1 -277.37,689.5 0,424.2 204.46,744.2 475.6,744.2 271.13,0 475.6,-320 475.6,-744.2 0,-185.4 -95.92,-423.8 -277.38,-689.5 -71.5,-104.6 -143.67,-194.7 -198.22,-259",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13554,4610.15 c 0,-391.16 -515.1,-708.26 -515.1,-708.26 0,0 -515.1,317.1 -515.1,708.26 0,391.16 230.7,708.27 515.1,708.27 284.5,0 515.1,-317.11 515.1,-708.27",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13038.9,3901.89 c 0,0 -257.5,192.75 -257.5,450.71 0,257.96 136,450.71 257.5,450.71 121.6,0 257.6,-192.75 257.6,-450.71 0,-257.96 -257.6,-450.71 -257.6,-450.71",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13747.2,3386.79 c -391.2,0 -708.3,515.1 -708.3,515.1 0,0 317.1,515.1 708.3,515.1 391.2,0 708.3,-230.62 708.3,-515.1 0,-284.49 -317.1,-515.1 -708.3,-515.1",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13038.9,3901.89 c 0,0 192.8,257.55 450.8,257.55 257.9,0 450.7,-135.97 450.7,-257.55 0,-121.58 -192.8,-257.55 -450.7,-257.55 -258,0 -450.8,257.55 -450.8,257.55",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12523.8,3193.6 c 0,391.19 515.1,708.29 515.1,708.29 0,0 515.1,-317.1 515.1,-708.29 0,-391.1 -230.6,-708.2 -515.1,-708.2 -284.4,0 -515.1,317.1 -515.1,708.2",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13038.9,3901.89 c 0,0 257.6,-192.76 257.6,-450.72 0,-257.97 -136,-450.67 -257.6,-450.67 -121.5,0 -257.5,192.7 -257.5,450.67 0,257.96 257.5,450.72 257.5,450.72",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12330.7,4416.99 c 391.1,0 708.2,-515.1 708.2,-515.1 0,0 -317.1,-515.1 -708.2,-515.1 -391.2,0 -708.3,230.61 -708.3,515.1 0,284.48 317.1,515.1 708.3,515.1",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13038.9,3901.89 c 0,0 -192.7,-257.55 -450.7,-257.55 -257.9,0 -450.7,135.97 -450.7,257.55 0,121.58 192.8,257.55 450.7,257.55 258,0 450.7,-257.55 450.7,-257.55",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2143.13,2356.6 c 0,-391.2 -629.57,-708.3 -629.57,-708.3 0,0 -629.572,317.1 -629.572,708.3 0,391.1 281.872,708.2 629.572,708.2 347.7,0 629.57,-317.1 629.57,-708.2",
    style: {
      fill: "#0b5d5e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1514,1795.1 c -56.76,33 -147.73,89.9 -237.26,163.3 -120.42,98.6 -263.98,247.8 -263.98,398.2 0,319.5 224.66,579.5 500.8,579.5 276.13,0 500.79,-260 500.79,-579.5 0,-225.8 -325.65,-460.4 -500.35,-561.5",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2322.75,906.102 c -391.16,0 -708.26,629.498 -708.26,629.498 0,0 317.1,629.6 708.26,629.6 391.16,0 708.26,-281.9 708.26,-629.6 0,-347.7 -317.1,-629.498 -708.26,-629.498",
    style: {
      fill: "#0b5d5e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2322.75,1034.8 c -225.82,0 -460.42,325.7 -561.46,500.4 32.94,56.7 89.88,147.7 163.23,237.2 98.65,120.4 247.82,264 398.23,264 319.53,0 579.49,-224.7 579.49,-500.8 0,-276.1 -259.96,-500.8 -579.49,-500.8",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 883.988,708.301 c 0,391.099 629.572,708.199 629.572,708.199 0,0 629.57,-317.1 629.57,-708.199 C 2143.13,317.102 1861.26,0 1513.56,0 1165.86,0 883.988,317.102 883.988,708.301",
    style: {
      fill: "#0b5d5e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1513.56,128.801 c -276.14,0 -500.8,259.898 -500.8,579.5 0,225.801 325.65,460.399 500.36,561.399 56.73,-32.9 147.71,-89.9 237.25,-163.2 120.43,-98.6 263.98,-247.801 263.98,-398.199 0,-319.602 -224.66,-579.5 -500.79,-579.5",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 708.266,2158.8 c 391.164,0 708.264,-629.6 708.264,-629.6 0,0 -317.1,-629.501 -708.264,-629.501 C 317.102,899.699 0,1181.5 0,1529.2 c 0,347.7 317.102,629.6 708.266,629.6",
    style: {
      fill: "#0b5d5e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 708.266,1028.4 c -319.528,0 -579.489,224.7 -579.489,500.8 0,276.2 259.961,500.8 579.489,500.8 225.816,0 460.414,-325.6 561.464,-500.3 -32.94,-56.8 -89.88,-147.7 -163.23,-237.3 -98.65,-120.4 -247.824,-264 -398.234,-264",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3959.43,5047.06 c -164.03,48.63 -342.62,-33.32 -470.13,-214.01 -127.51,180.69 -306.1,262.64 -470.14,214.01 -230.13,-68.22 -344.38,-367.41 -238.27,-725.39 106.12,-357.98 650,-663.55 650,-663.55 h 116.82 c 0,0 543.88,305.57 649.99,663.55 106.12,357.98 -8.14,657.17 -238.27,725.39",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3375.22,3845.07 c -169.44,88.16 -412.51,241.41 -470.86,391.6 -42.92,110.51 -46,216.97 -8.65,299.79 21.85,48.47 67.35,110.64 160.05,131.61 19,4.29 38.62,6.47 58.34,6.47 93.87,0 192.27,-48.2 269.98,-132.23 l 105.22,-113.76 105.22,113.76 c 77.7,84.03 176.11,132.23 269.97,132.23 19.73,0 39.35,-2.18 58.35,-6.47 167.15,-37.81 232.24,-223.27 151.4,-431.4 -58.35,-150.18 -301.39,-303.41 -470.86,-391.59 l -228.16,-0.01",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4969.8,3025.7 c 48.63,164 -33.32,342.62 -214.01,470.12 180.69,127.51 262.64,306.1 214.01,470.14 -68.22,230.13 -367.41,344.38 -725.39,238.27 -357.98,-106.12 -663.55,-650 -663.55,-650 v -116.82 c 0,0 305.57,-543.91 663.55,-650.01 357.98,-106.1 657.17,8.2 725.39,238.3",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3767.81,3609.9 c 88.16,169.44 241.41,412.52 391.6,470.86 110.51,42.92 216.97,46 299.79,8.66 48.47,-21.86 110.64,-67.36 131.61,-160.06 4.29,-18.99 6.47,-38.62 6.47,-58.34 0,-93.87 -48.2,-192.27 -132.23,-269.98 l -113.77,-105.22 113.77,-105.22 c 84.03,-77.7 132.23,-176.1 132.23,-270 0,-19.7 -2.18,-39.3 -6.47,-58.3 -37.81,-167.2 -223.28,-232.3 -431.4,-151.4 -150.18,58.3 -303.41,301.4 -391.59,470.84 l -0.01,228.16",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2992.15,2012.2 c 164.04,-48.6 342.63,33.4 470.13,214 127.51,-180.6 306.1,-262.6 470.14,-214 230.13,68.3 344.38,367.5 238.27,725.4 -106.12,358 -650,663.58 -650,663.58 h -116.82 c 0,0 -543.88,-305.58 -649.99,-663.58 -106.12,-357.9 8.14,-657.1 238.27,-725.4",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3576.36,3214.2 c 169.44,-88.1 412.52,-241.4 470.86,-391.6 42.93,-110.5 46,-216.9 8.66,-299.8 -21.86,-48.4 -67.36,-110.6 -160.06,-131.6 -18.99,-4.3 -38.62,-6.4 -58.34,-6.4 -93.87,0 -192.27,48.2 -269.98,132.2 L 3462.28,2630.8 3357.06,2517 c -77.7,-84 -176.1,-132.2 -269.97,-132.2 -19.73,0 -39.35,2.1 -58.35,6.4 -167.15,37.8 -232.24,223.3 -151.4,431.4 58.35,150.2 301.39,303.4 470.86,391.6 h 228.16",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1976.98,4018.63 c -48.63,-164.04 33.32,-342.63 214.01,-470.14 -180.69,-127.5 -262.64,-306.09 -214.01,-470.09 68.22,-230.2 367.41,-344.4 725.39,-238.3 357.98,106.1 663.55,649.99 663.55,649.99 v 116.81 c 0,0 -305.57,543.88 -663.55,650 -357.98,106.11 -657.17,-8.14 -725.39,-238.27",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3178.97,3434.41 C 3090.81,3265 2937.56,3021.9 2787.37,2963.6 c -110.51,-43 -216.97,-46 -299.79,-8.7 -48.47,21.9 -110.64,67.4 -131.61,160.1 -4.29,19 -6.47,38.6 -6.47,58.3 0,93.9 48.2,192.27 132.23,269.98 l 113.77,105.22 -113.77,105.21 c -84.03,77.71 -132.23,176.11 -132.23,269.98 0,19.73 2.18,39.35 6.47,58.35 37.81,167.15 223.28,232.24 431.4,151.39 150.18,-58.34 303.41,-301.38 391.59,-470.85 l 0.01,-228.17",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5750.26,2253.6 c 0,-128.1 -103.77,-231.8 -231.79,-231.8 -128.02,0 -231.8,103.7 -231.8,231.8 0,128 103.78,231.8 231.8,231.8 128.02,0 231.79,-103.8 231.79,-231.8",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5518.47,2150.5 c -56.8,0 -103.02,46.3 -103.02,103.1 0,56.8 46.22,103 103.02,103 56.8,0 103.02,-46.2 103.02,-103 0,-56.8 -46.22,-103.1 -103.02,-103.1",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6042.19,1876.6 c -90.53,-90.5 -237.29,-90.5 -327.81,0 -90.52,90.5 -90.52,237.3 0,327.8 90.52,90.5 237.28,90.5 327.81,0 90.52,-90.5 90.52,-237.3 0,-327.8",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5878.28,1937.5 c -27.52,0 -53.39,10.7 -72.85,30.2 -40.16,40.1 -40.16,105.5 0,145.7 19.46,19.4 45.33,30.1 72.85,30.1 27.52,0 53.39,-10.7 72.85,-30.1 19.46,-19.5 30.17,-45.4 30.17,-72.9 0,-27.5 -10.71,-53.4 -30.17,-72.8 -19.46,-19.5 -45.33,-30.2 -72.85,-30.2",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5982.06,1403.6 c -128.02,0 -231.8,103.8 -231.8,231.8 0,128.1 103.78,231.8 231.8,231.8 128.02,0 231.8,-103.7 231.8,-231.8 0,-128 -103.78,-231.8 -231.8,-231.8",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5982.06,1532.4 c -56.8,0 -103.02,46.2 -103.02,103 0,56.8 46.22,103.1 103.02,103.1 56.8,0 103.02,-46.3 103.02,-103.1 0,-56.8 -46.22,-103 -103.02,-103",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5605.11,1111.7 c -90.52,90.5 -90.52,237.3 0,327.8 90.52,90.6 237.28,90.6 327.81,0 90.52,-90.5 90.52,-237.3 0,-327.8 -90.53,-90.5 -237.29,-90.5 -327.81,0",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5769.01,1172.6 c -27.51,0 -53.38,10.7 -72.84,30.2 -19.46,19.4 -30.18,45.3 -30.18,72.8 0,27.5 10.72,53.4 30.17,72.9 19.46,19.4 45.33,30.1 72.85,30.1 27.52,0 53.39,-10.7 72.85,-30.1 19.46,-19.5 30.17,-45.4 30.17,-72.9 0,-27.5 -10.71,-53.4 -30.17,-72.8 -19.47,-19.5 -45.33,-30.2 -72.85,-30.2",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5132.14,1171.9 c 0,128 103.78,231.7 231.8,231.7 128.02,0 231.79,-103.7 231.79,-231.7 0,-128.1 -103.77,-231.798 -231.79,-231.798 -128.02,0 -231.8,103.698 -231.8,231.798",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5363.94,1068.8 c -56.81,0 -103.02,46.3 -103.02,103.1 0,56.8 46.21,103 103.02,103 56.8,0 103.02,-46.2 103.02,-103 0,-56.8 -46.22,-103.1 -103.02,-103.1",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4840.22,1548.8 c 90.52,90.5 237.29,90.5 327.81,0 90.52,-90.5 90.52,-237.3 0,-327.8 -90.52,-90.5 -237.29,-90.5 -327.81,0 -90.52,90.5 -90.52,237.3 0,327.8",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5004.13,1281.9 c -27.52,0 -53.39,10.7 -72.85,30.2 -19.46,19.4 -30.18,45.3 -30.18,72.8 0,27.5 10.72,53.4 30.18,72.8 19.46,19.5 45.33,30.2 72.85,30.2 27.52,0 53.39,-10.7 72.85,-30.2 40.16,-40.1 40.16,-105.5 0,-145.6 -19.46,-19.5 -45.33,-30.2 -72.85,-30.2",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4900.35,2021.8 c 128.01,0 231.79,-103.8 231.79,-231.8 0,-128 -103.78,-231.8 -231.79,-231.8 -128.02,0 -231.8,103.8 -231.8,231.8 0,128 103.78,231.8 231.8,231.8",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4900.35,1687 c -56.81,0 -103.02,46.2 -103.02,103 0,56.8 46.21,103 103.02,103 56.8,0 103.02,-46.2 103.02,-103 0,-56.8 -46.22,-103 -103.02,-103",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5277.3,2313.7 c 90.52,-90.5 90.52,-237.3 0,-327.8 -90.52,-90.5 -237.29,-90.5 -327.81,0 -90.52,90.5 -90.52,237.3 0,327.8 90.52,90.5 237.29,90.5 327.81,0",
    style: {
      fill: "#f47515",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5113.4,2046.8 c -27.52,0 -53.39,10.7 -72.85,30.1 -19.46,19.5 -30.18,45.4 -30.18,72.9 0,27.5 10.72,53.4 30.18,72.8 19.46,19.5 45.33,30.2 72.85,30.2 27.51,0 53.38,-10.7 72.84,-30.2 19.46,-19.4 30.18,-45.3 30.18,-72.8 0,-27.5 -10.72,-53.4 -30.17,-72.9 -19.46,-19.4 -45.33,-30.1 -72.85,-30.1",
    style: {
      fill: "#674fac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11850.2,2428.2 c -50.2,-200.1 -228.9,-344.2 -366.2,-428.3 -95.9,-58.7 -220.9,-27.4 -277.6,69.6 -81.4,139.1 -171,350.3 -120.8,550.4 84.8,337.9 324.6,568.8 535.8,515.8 211.1,-52.9 313.6,-369.7 228.8,-707.5",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11379.4,2099 c -25.7,0 -48.9,13.3 -61.9,35.6 -70.5,120.5 -146.3,297.1 -107,454 51.4,204.8 199.6,425.9 349.3,425.9 10.4,0 20.3,-1.2 30.2,-3.7 121.8,-30.5 207.3,-264.4 135.3,-551.3 -39.3,-156.9 -189.5,-276.9 -308.6,-349.8 -11.5,-7.1 -24.1,-10.7 -37.3,-10.7",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11893.2,2372.2 c -206.3,0 -389.4,-138.3 -504.5,-251 -80.3,-78.7 -80.3,-207.6 0,-286.2 115.1,-112.8 298.2,-251.1 504.5,-251.1 348.3,0 630.6,176.5 630.6,394.2 0,217.6 -282.3,394.1 -630.6,394.1",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11893.2,1712.7 c -161.8,0 -314.6,116.5 -414.4,214.2 -13.9,13.7 -21.5,31.8 -21.5,51.2 0,19.3 7.6,37.5 21.5,51.1 99.8,97.7 252.6,214.2 414.4,214.2 295.8,0 501.9,-139.8 501.9,-265.3 0,-125.5 -206.1,-265.4 -501.9,-265.4",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14333.2,1641.5 c -50.2,-200.1 -228.9,-344.1 -366.3,-428.3 -95.8,-58.7 -220.8,-27.4 -277.6,69.6 -81.4,139.1 -170.9,350.4 -120.7,550.4 84.7,337.9 324.6,568.8 535.7,515.8 211.1,-52.9 313.6,-369.7 228.9,-707.5",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13862.3,1312.3 c -25.7,0 -48.8,13.3 -61.8,35.6 -70.6,120.5 -146.4,297.1 -107,454 51.4,204.8 199.5,425.9 349.3,425.9 10.4,0 20.3,-1.2 30.2,-3.7 121.7,-30.5 207.2,-264.4 135.3,-551.3 -39.4,-156.9 -189.6,-276.9 -308.6,-349.8 -11.6,-7.1 -24.1,-10.7 -37.4,-10.7",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14376.2,1585.5 c -206.3,0 -389.5,-138.3 -504.5,-251 -80.3,-78.7 -80.3,-207.6 0,-286.2 115,-112.8 298.2,-251.101 504.5,-251.101 348.3,0 630.6,176.5 630.6,394.201 0,217.6 -282.3,394.1 -630.6,394.1",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14376.2,926 c -161.8,0 -314.7,116.5 -414.4,214.2 -13.9,13.7 -21.6,31.8 -21.6,51.2 0,19.3 7.7,37.5 21.6,51.1 99.7,97.7 252.6,214.2 414.4,214.2 295.7,0 501.8,-139.8 501.8,-265.3 0,-125.5 -206.1,-265.4 -501.8,-265.4",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10463.8,3784.59 C 9910.97,2956.4 9102.77,2680.3 8570.39,3035.6 c -532.38,355.4 -587.34,1207.71 -34.55,2035.86 552.78,828.15 2179.36,1177.37 2179.36,1177.37 0,0 301.3,-1636.1 -251.4,-2464.24",
    style: {
      fill: "#171a4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8641.88,3142.7 c -226.61,151.3 -356.94,413.22 -366.99,737.54 -10.85,350.23 119.86,747.9 368.05,1119.73 428.61,642.11 1575.26,988.31 1966.46,1090.44 55.5,-400.6 175.3,-1593.06 -252.8,-2234.33 -248.2,-371.84 -565.25,-645.08 -892.86,-769.38 -303.38,-115.1 -595.26,-95.2 -821.86,56",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8713.37,3249.8 c -191.02,127.56 -301.03,352.86 -309.76,634.44 -10.03,323.66 113,694.51 346.44,1044.23 362.17,542.58 1305.25,869.66 1750.05,998.26 51.7,-460.37 111.1,-1457.33 -250.6,-1999.16 -233.4,-349.73 -528.7,-605.57 -831.45,-720.47 -263.38,-99.9 -513.64,-84.8 -704.68,42.7",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9273.42,5071.71 C 9845.3,4256.63 9810.16,3403.27 9286.18,3035.6 8762.2,2668 7947.79,2925.3 7375.92,3740.4 c -571.87,815.08 -308.6,2457.74 -308.6,2457.74 0,0 1634.23,-311.35 2206.1,-1126.43",
    style: {
      fill: "#171a4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9212.22,3141.1 c -223.04,-156.5 -514.37,-183.2 -820.33,-75.2 -330.41,116.7 -653.79,382.5 -910.55,748.46 -443.41,631.98 -351.06,1826.15 -304.64,2227.8 393.54,-93.22 1548.48,-413.26 1991.31,-1044.41 256.77,-365.97 396.68,-760.48 393.96,-1110.87 -2.51,-324.47 -126.73,-589.38 -349.75,-745.78",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9138.25,3246.5 c -188.01,-131.9 -437.86,-152.9 -703.49,-59.1 -305.35,107.8 -606.51,356.71 -848.01,700.92 -374.67,534.01 -338.19,1531.5 -297.04,1992.7 447.86,-118.46 1398.72,-423.95 1772.88,-957.23 241.51,-344.22 373.13,-712.11 370.61,-1035.91 -2.19,-281.7 -106.93,-509.49 -294.95,-641.38",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10077.1,4545.76 c 0,-995.68 -518.88,-1674.06 -1158.96,-1674.06 -640.09,0 -1158.98,678.38 -1158.98,1674.06 0,995.69 1158.98,2189.18 1158.98,2189.18 0,0 1158.96,-1193.49 1158.96,-2189.18",
    style: {
      fill: "#171a4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8918.14,3000.5 c -272.46,0 -526.26,145.4 -714.68,409.62 -203.47,285.27 -315.53,688.59 -315.53,1135.64 0,772.03 761.48,1696.54 1030.16,1998.68 268.62,-302.35 1030.25,-1227.67 1030.25,-1998.68 0,-447.06 -112.05,-850.37 -315.53,-1135.64 C 9444.4,3145.9 9190.58,3000.5 8918.14,3000.5",
    style: {
      fill: "#09959e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8918.14,3129.2 c -229.68,0 -446.26,126.4 -609.84,355.7 -188.04,263.63 -291.59,640.39 -291.59,1060.86 0,652.35 602.77,1447.94 901.34,1801.86 298.59,-354.2 901.51,-1150.41 901.51,-1801.86 0,-420.49 -103.55,-797.24 -291.59,-1060.86 -163.58,-229.3 -380.15,-355.7 -609.83,-355.7",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13296.5,3901.89 c 0,-142.24 -115.3,-257.55 -257.6,-257.55 -142.2,0 -257.5,115.31 -257.5,257.55 0,142.24 115.3,257.55 257.5,257.55 142.3,0 257.6,-115.31 257.6,-257.55",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13038.9,3773.11 c -71,0 -128.7,57.77 -128.7,128.78 0,71.01 57.7,128.77 128.7,128.77 71.1,0 128.8,-57.76 128.8,-128.77 0,-71.01 -57.7,-128.78 -128.8,-128.78",
    style: {
      fill: "#ef363d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16258.3,2871.7 c 0,-213.4 -172.9,-386.3 -386.3,-386.3 -213.4,0 -386.3,172.9 -386.3,386.3 0,213.3 172.9,386.3 386.3,386.3 213.4,0 386.3,-173 386.3,-386.3",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15872,2678.5 c -106.5,0 -193.2,86.7 -193.2,193.2 0,106.5 86.7,193.1 193.2,193.1 106.5,0 193.2,-86.6 193.2,-193.1 0,-106.5 -86.7,-193.2 -193.2,-193.2",
    style: {
      fill: "#ef363d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16387.1,2807.3 c 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4 35.6,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16709,2807.3 c 0,-35.6 -28.8,-64.4 -64.3,-64.4 -35.6,0 -64.4,28.8 -64.4,64.4 0,35.6 28.8,64.4 64.4,64.4 35.5,0 64.3,-28.8 64.3,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17031,2807.3 c 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.6,0 -64.4,28.8 -64.4,64.4 0,35.6 28.8,64.4 64.4,64.4 35.6,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17352.9,2807.3 c 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4 35.6,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17674.9,2807.3 c 0,-35.6 -28.9,-64.4 -64.4,-64.4 -35.6,0 -64.4,28.8 -64.4,64.4 0,35.6 28.8,64.4 64.4,64.4 35.5,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14197.9,2807.3 c 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4 35.6,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14519.9,2807.3 c 0,-35.6 -28.9,-64.4 -64.4,-64.4 -35.6,0 -64.4,28.8 -64.4,64.4 0,35.6 28.8,64.4 64.4,64.4 35.5,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14841.8,2807.3 c 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4 35.6,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15163.7,2807.3 c 0,-35.6 -28.8,-64.4 -64.3,-64.4 -35.6,0 -64.4,28.8 -64.4,64.4 0,35.6 28.8,64.4 64.4,64.4 35.5,0 64.3,-28.8 64.3,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15485.7,2807.3 c 0,-35.6 -28.9,-64.4 -64.4,-64.4 -35.6,0 -64.4,28.8 -64.4,64.4 0,35.6 28.8,64.4 64.4,64.4 35.5,0 64.4,-28.8 64.4,-64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,3386.79 c 35.6,0 64.4,-28.83 64.4,-64.39 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.56 28.9,64.39 64.4,64.39",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,3708.72 c 35.6,0 64.4,-28.82 64.4,-64.38 0,-35.56 -28.8,-64.39 -64.4,-64.39 -35.5,0 -64.4,28.83 -64.4,64.39 0,35.56 28.9,64.38 64.4,64.38",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,4030.66 c 35.6,0 64.4,-28.82 64.4,-64.38 0,-35.57 -28.8,-64.39 -64.4,-64.39 -35.5,0 -64.4,28.82 -64.4,64.39 0,35.56 28.9,64.38 64.4,64.38",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,4352.6 c 35.6,0 64.4,-28.83 64.4,-64.39 0,-35.56 -28.8,-64.38 -64.4,-64.38 -35.5,0 -64.4,28.82 -64.4,64.38 0,35.56 28.9,64.39 64.4,64.39",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,4674.54 c 35.6,0 64.4,-28.83 64.4,-64.39 0,-35.56 -28.8,-64.39 -64.4,-64.39 -35.5,0 -64.4,28.83 -64.4,64.39 0,35.56 28.9,64.39 64.4,64.39",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,1197.6 c 35.6,0 64.4,-28.8 64.4,-64.4 0,-35.5 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.9 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,1519.5 c 35.6,0 64.4,-28.8 64.4,-64.3 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.5 28.9,64.3 64.4,64.3",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,1841.5 c 35.6,0 64.4,-28.8 64.4,-64.4 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,2163.4 c 35.6,0 64.4,-28.8 64.4,-64.4 0,-35.5 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.9 -64.4,64.4 0,35.6 28.9,64.4 64.4,64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15807.6,2485.4 c 35.6,0 64.4,-28.9 64.4,-64.4 0,-35.6 -28.8,-64.4 -64.4,-64.4 -35.5,0 -64.4,28.8 -64.4,64.4 0,35.5 28.9,64.4 64.4,64.4",
    style: {
      fill: "#070604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3963.46,546.402 c 200.71,47.7 346.96,224.496 432.84,360.797 59.94,95.101 30.16,220.501 -66.14,278.501 -137.99,83.1 -348.15,175.3 -548.86,127.6 -338.85,-80.4 -572.77,-317.402 -522.47,-529.198 50.3,-211.7 365.78,-318.204 704.63,-237.7",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3811.06,1188 c 157.42,37.4 333.04,-40.6 452.67,-112.6 16.68,-10.1 28.32,-26 32.79,-44.8 4.47,-18.8 1.22,-38.299 -9.16,-54.702 C 4212.91,857.699 4091.13,709.102 3933.7,671.699 3645.97,603.301 3413.12,691.801 3384.12,813.902 3355.12,936 3523.32,1119.7 3811.06,1188",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7273.81,997.301 c 50.19,200.099 228.88,344.099 366.23,428.199 95.85,58.8 220.84,27.4 277.62,-69.6 81.37,-139 170.93,-350.3 120.74,-550.4 -84.74,-337.801 -324.6,-568.801 -535.73,-515.801 -211.14,53 -313.6,369.699 -228.86,707.602",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7744.67,1326.4 c 25.69,0 48.82,-13.3 61.84,-35.5 70.54,-120.6 146.35,-297.099 106.98,-454.099 C 7862.11,632 7713.97,410.898 7564.21,410.898 c -10.43,0 -20.31,1.204 -30.21,3.704 -121.74,30.5 -207.24,264.5 -135.29,551.296 39.36,157.002 189.56,276.902 308.61,349.802 11.54,7.1 24.1,10.7 37.35,10.7",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7230.8,1053.2 c 206.3,0 389.46,138.3 504.51,251 80.29,78.7 80.29,207.6 0,286.3 -115.05,112.7 -298.21,251 -504.51,251 -348.28,0 -630.62,-176.5 -630.62,-394.2 0,-217.6 282.34,-394.1 630.62,-394.1",
    style: {
      fill: "#1d4d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7230.8,1712.7 c 161.81,0 314.64,-116.5 414.38,-214.2 13.9,-13.7 21.56,-31.8 21.56,-51.2 0,-19.3 -7.66,-37.5 -21.56,-51.1 -99.74,-97.7 -252.57,-214.2 -414.38,-214.2 -295.74,0 -501.84,139.8 -501.84,265.3 0,125.6 206.1,265.4 501.84,265.4",
    style: {
      fill: "#256b30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2821.75,1532.4 c 0,-146.1 -118.45,-264.5 -264.56,-264.5 -146.11,0 -264.55,118.4 -264.55,264.5 0,146.1 118.44,264.6 264.55,264.6 146.11,0 264.56,-118.5 264.56,-264.6",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2709.04,1532.4 c 0,-83.8 -67.98,-151.8 -151.85,-151.8 -83.86,0 -151.85,68 -151.85,151.8 0,83.9 67.99,151.9 151.85,151.9 83.87,0 151.85,-68 151.85,-151.9",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2473.64,1482.4 h -820.42 v 100.1 h 820.42 v -100.1",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1526.44,211.402 c -146.11,0 -264.56,118.399 -264.56,264.496 C 1261.88,622 1380.33,740.5 1526.44,740.5 1672.55,740.5 1791,622 1791,475.898 1791,329.801 1672.55,211.402 1526.44,211.402",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1526.44,324.102 c -83.86,0 -151.85,67.898 -151.85,151.796 0,83.903 67.99,151.903 151.85,151.903 83.87,0 151.85,-68 151.85,-151.903 0,-83.898 -67.98,-151.796 -151.85,-151.796",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1576.52,559.5 h -100.16 v 820.4 h 100.16 V 559.5",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 199.402,1535.3 c 0,146.1 118.446,264.6 264.559,264.6 146.109,0 264.555,-118.5 264.555,-264.6 0,-146.1 -118.446,-264.5 -264.555,-264.5 -146.113,0 -264.559,118.4 -264.559,264.5",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 312.109,1535.3 c 0,83.9 67.989,151.9 151.852,151.9 83.863,0 151.848,-68 151.848,-151.9 0,-83.8 -67.985,-151.8 -151.848,-151.8 -83.863,0 -151.852,68 -151.852,151.8",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1367.93,1485.3 H 547.504 v 100.1 h 820.426 v -100.1",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1505.29,2862.4 c 146.11,0 264.56,-118.5 264.56,-264.6 0,-146.1 -118.45,-264.5 -264.56,-264.5 -146.11,0 -264.56,118.4 -264.56,264.5 0,146.1 118.45,264.6 264.56,264.6",
    style: {
      fill: "#eff149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1505.29,2749.7 c 83.86,0 151.85,-68 151.85,-151.9 0,-83.8 -67.99,-151.8 -151.85,-151.8 -83.86,0 -151.85,68 -151.85,151.8 0,83.9 67.99,151.9 151.85,151.9",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1555.37,1693.8 h -100.16 v 820.5 h 100.16 v -820.5",
    style: {
      fill: "#242a76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1964.27,1519.5 c 0,-248.9 -201.79,-450.7 -450.71,-450.7 -248.92,0 -450.72,201.8 -450.72,450.7 0,249 201.8,450.8 450.72,450.8 248.92,0 450.71,-201.8 450.71,-450.8",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1830.97,1519.5 c 0,-175.3 -142.11,-317.4 -317.41,-317.4 -175.3,0 -317.41,142.1 -317.41,317.4 0,175.3 142.11,317.5 317.41,317.5 175.3,0 317.41,-142.2 317.41,-317.5",
    style: {
      fill: "#ef363d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3546.72,3898.29 344.33,524.05 c 11.9,18.12 6.87,42.44 -11.24,54.34 l -6.17,4.06 c -18.11,11.9 -42.44,6.86 -54.34,-11.25 l -215.05,-327.3 c -21.39,-32.56 -72.03,-17.41 -72.03,21.55 v 225.57 c 0,21.67 -17.56,39.23 -39.23,39.23 h -7.38 c -21.67,0 -39.24,-17.56 -39.24,-39.23 v -225.58 c 0,-38.95 -50.63,-54.1 -72.03,-21.54 l -218.69,342.82 c -11.9,18.11 -36.23,23.15 -54.34,11.25 l -6.16,-4.05 c -18.11,-11.9 -23.15,-36.23 -11.25,-54.34 l 347.98,-539.58 c 11.9,-18.11 36.23,-23.14 54.34,-11.24 v 0 h 6.16 v 0 c 18.11,-11.9 42.44,-6.87 54.34,11.24",
    style: {
      fill: "#31b240",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3521.53,3155.7 344.33,-524 c 11.9,-18.1 6.86,-42.5 -11.25,-54.4 l -6.16,-4 c -18.11,-11.9 -42.44,-6.9 -54.34,11.2 l -215.05,327.3 c -21.39,32.6 -72.03,17.4 -72.03,-21.5 v -225.6 c 0,-21.6 -17.57,-39.2 -39.24,-39.2 h -7.37 c -21.67,0 -39.24,17.6 -39.24,39.2 v 225.6 c 0,39 -50.64,54.1 -72.03,21.5 L 3130.46,2569 c -11.9,-18.1 -36.23,-23.1 -54.34,-11.2 l -6.17,4 c -18.11,11.9 -23.14,36.3 -11.24,54.4 l 347.97,539.5 c 11.9,18.1 36.23,23.2 54.34,11.3 v 0 h 6.17 v 0 c 18.11,11.9 42.44,6.8 54.34,-11.3",
    style: {
      fill: "#31b240",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3846.16,3455.17 524.05,-344.37 c 18.11,-11.9 42.44,-6.8 54.34,11.3 l 4.05,6.2 c 11.9,18.1 6.87,42.4 -11.24,54.3 l -327.3,215.04 c -32.56,21.39 -17.41,72.03 21.54,72.03 h 225.57 c 21.67,0 39.24,17.57 39.24,39.24 v 7.37 c 0,21.67 -17.57,39.24 -39.24,39.24 H 4111.6 c -38.96,0 -54.1,50.64 -21.55,72.03 l 342.83,218.69 c 18.11,11.9 23.14,36.23 11.24,54.34 l -4.05,6.17 c -11.9,18.11 -36.23,23.14 -54.34,11.24 l -539.57,-347.97 c -18.11,-11.9 -23.15,-36.23 -11.25,-54.34 v 0 -6.17 0 c -11.9,-18.11 -6.86,-42.44 11.25,-54.34",
    style: {
      fill: "#31b240",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3103.6,3480.37 2579.55,3136 c -18.11,-11.9 -42.44,-6.8 -54.34,11.3 l -4.05,6.1 c -11.9,18.2 -6.87,42.5 11.24,54.4 l 327.3,215.03 c 32.56,21.4 17.41,72.03 -21.54,72.03 h -225.57 c -21.67,0 -39.24,17.57 -39.24,39.24 v 7.38 c 0,21.67 17.57,39.23 39.24,39.23 h 225.57 c 38.96,0 54.1,50.64 21.55,72.03 l -342.83,218.7 c -18.11,11.9 -23.14,36.22 -11.24,54.33 l 4.05,6.17 c 11.9,18.11 36.23,23.15 54.34,11.25 l 539.57,-347.98 c 18.11,-11.9 23.15,-36.23 11.25,-54.34 v 0 -6.17 0 c 11.9,-18.11 6.86,-42.43 -11.25,-54.33",
    style: {
      fill: "#31b240",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3940.01,3495.82 c 0,-248.92 -201.79,-450.72 -450.71,-450.72 -248.92,0 -450.72,201.8 -450.72,450.72 0,248.92 201.8,450.72 450.72,450.72 248.92,0 450.71,-201.8 450.71,-450.72",
    style: {
      fill: "#c41f25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3806.71,3495.82 c 0,-175.32 -142.11,-317.42 -317.41,-317.42 -175.3,0 -317.41,142.1 -317.41,317.42 0,175.3 142.11,317.41 317.41,317.41 175.3,0 317.41,-142.11 317.41,-317.41",
    style: {
      fill: "#ef363d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitapisskoFinal);
export default __webpack_public_path__ + "static/media/AitapisskoFINAL.44db1468d09b1cbf507de7bb6cdf69f8.svg";
export { ForwardRef as ReactComponent };